import axios from 'axios';
import { Toast } from 'vant';
import {startWxAuth} from "@/utils/auth";
import router from '@/router';
import storage from "@/utils/storage";


const service = axios.create({
    // baseURL: process.env.VUE_APP_BASE_API, // 从 .env 读取
    /*timeout: 5000,*/
    withCredentials: true
});

// 请求拦截器：加入 Token
service.interceptors.request.use(config => {
    /*const token = localStorage.getItem('token');*/
    const token = storage.get('token');
    /*console.log('token',token)*/
    if (token) config.headers['Authorization'] = 'Bearer ' + token;
    // 1. 从 router 实例获取当前路由参数
    // 假设你的路由定义是 /:prefix/api/...
    // 1. 获取当前路由前缀
    const per_prefix = router.currentRoute.params.prefix;
    // 2. 核心逻辑：不管 URL 带不带前缀，API 最终都要拼上 'prod'
    // 如果后期想改回去（没前缀就走默认），只需要把这一行改成：const prefix = per_prefix;
    const prefix = per_prefix === undefined ? 'prod' : per_prefix;

    // 2. 动态拼接 baseURL
    const baseApi = prefix?process.env.VUE_APP_BASE:process.env.VUE_APP_BASE_API; // 例如 http://localhost:8001

    // 如果有前缀就拼上，没有就用默认的
    config.baseURL = prefix
        ? `${baseApi}${prefix}/api`
        : `${baseApi}`;

    return config;
});
// 定义一个标志位，防止并发请求导致重复跳转
let isRedirecting = false;

// 响应拦截器：统一处理错误提示
service.interceptors.response.use(response => {
    const res = response.data;
    if (res.code !== 200) {
        // 如果后端返回 401，说明 Token 失效或未登录
        /*if (res.code === 401) {
            startWxAuth();
        }*/
        // Toast(res.msg || '系统错误');
        /*return Promise.reject(new Error(res.msg));*/
        if (res.code === 401) {
            localStorage.removeItem('token');
            // 如果已经在跳转中，直接返回 reject，不再触发新的跳转
            if (isRedirecting) {
                return Promise.reject(new Error('正在跳转登录...'));
            }

            const prefix = router.currentRoute.params.prefix;
            const pathPrefix = prefix ? `/${prefix}/` : '/';
            const loginPath = `${pathPrefix}login.html`;

            // 如果当前不在登录页，则启动跳转
            if (router.currentRoute.path !== loginPath) {
                isRedirecting = true; // 上锁

                router.replace(loginPath).then(() => {
                    isRedirecting = false; // 跳转成功后解锁
                }).catch(err => {
                    isRedirecting = false; // 无论成功失败都解锁
                    if (err.name !== 'NavigationDuplicated') {
                        console.error('Navigation Error:', err);
                    }
                });
            }
            // 401 必须 reject，否则页面里的 .then(res => ...) 会继续执行
            return Promise.reject(res.msg||'未登录或登录失效');
        }
    }
    return res;
}, error => {
    console.log('完整的error对象:', error);

    // 1. 默认的错误提示信息
    let errorMsg = '网络异常';

    // 2. 判断是否有服务器返回的响应体
    if (error.response && error.response.data) {
        // 这里的 error.response.data 就是后端返回的 JSON 对象
        // 根据你后端的字段名，可能是 .msg、.message 或 .errorMsg
        errorMsg = error.response.data.msg || error.response.data.message || errorMsg;
    } else if (error.message) {
        // 如果是断网、超时等情况，拿 Axios 自身的错误信息（比如 "Network Error"）
        errorMsg = error.message;
    }

    // 3. 弹出提示
    Toast(errorMsg);

    // 4. 继续抛出错误，方便页面上的请求捕获
    return Promise.reject(error);
});

export default service;